function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function slideDown(target, duration = 300, showDisplay = 'block', checkHidden = true) {
  let display = window.getComputedStyle(target).display;
  if (checkHidden && display !== 'none') {
    return;
  }
  target.style.removeProperty('display');
  if (display === 'none') display = showDisplay;
  target.style.display = display;
  target.style.pointerEvents = 'none';
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    target.style.pointerEvents = 'auto';
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

function slideUp(target, duration = 300) {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.height = target.offsetHeight + 'px';
  target.style.pointerEvents = 'none';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.pointerEvents = 'auto';
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

function accessibilityEventListeners() {
  document.body.classList.add('no-outline');
  if (document.body.style.overflow === 'hidden') {
    document.body.style.overflow = null;
  }

  document.addEventListener('mousedown', (e) => {
    if (!document.body.classList.contains('no-outline')) {
      document.body.classList.add('no-outline');
    }
  })

  document.addEventListener('keydown', (e) => {
    if (document.body.classList.contains('no-outline') && (e.keyCode == 13 || e.keyCode == 9 || e.keyCode == 38 || e.keyCode == 40)) {
      document.body.classList.remove('no-outline');
    }
  })
}

window.addEventListener('DOMContentLoaded', () => {
  accessibilityEventListeners();
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (!event.code) return;
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (!event.code) return;
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    // case when we have modal inside other modal
    if (!this.openedBy?.closest('personalize-modal')) {
      document.body.classList.remove('overflow-hidden');
    }

    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = JSON.parse(this.getAttribute('data-enable-looping') || 'false');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (((isFirstSlide && event.currentTarget.name === 'previous') || (isLastSlide && event.currentTarget.name === 'next')) && this.enableSliderLooping) {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? 0
          : this.sliderItemOffset * this.sliderItemsToShow.length;

    } else {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
    }

    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider && this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class BundleSliderComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderItems = this.querySelectorAll('[id^="Bundle-Slide-"]');
    this.progress = this.querySelector('[id^="Progress-"]');
    this.bundleButton = document.querySelector('bundle-submit-button');
    this.connectedBtns = document.querySelectorAll(`.slider-additional-buttons[data-connected-slider="${this.id}"]`)
    this.btnMounted = false;

    this.additionalBtnsListener();
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    // HACK: took out the +1 here to get bundle working
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;
    super.update();
  }

  update() {
    super.update();
    if (this.bundleButton && this.currentPage === this.totalPages && !this.btnMounted) {
      this.bundleButton.classList.remove('hidden');
      this.bundleButton.checkBundleItemsAvailability();
      this.btnMounted = true;
    }
    if (!this.progress) return;
    this.progress.value = this.currentPage;
  }

  additionalBtnsListener() {
    if (!this.connectedBtns || !this.connectedBtns.length) return;

    this.connectedBtns.forEach(connectedBtn => {
      const additionalPrevButton = connectedBtn.querySelector('button[name="previous"]');
      const additionalNextButton = connectedBtn.querySelector('button[name="next"]');

      if (additionalPrevButton) additionalPrevButton.addEventListener('click', () => this.prevButton.click());
      if (additionalNextButton) additionalNextButton.addEventListener('click', () => this.nextButton.click());
    })
  }

  toggleAdditionalBtns(disable) {
    if (!this.connectedBtns || !this.connectedBtns.length) return;

    this.connectedBtns.forEach(connectedBtn => {
      connectedBtn?.classList.toggle('hidden', !disable);
    })
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Bundle-Slide-"]');
    this.initPages();
  }
}

customElements.define('bundle-slider-component', BundleSliderComponent);

class BundleSubmitButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button[name="bundle_submit"]');
    this.additionalSubmitBtn = document.querySelector('button[name="bundle_submit_ads"]');
    this.lookedCount = Number(this.dataset.bundleItemsCount);
    this.productForms = document.querySelectorAll('bundle-slider-component product-form');
    this.variantSwatches = document.querySelectorAll('variant-radios');

    this.btnsArray = [this.button];
    this.additionalSubmitBtn && (this.btnsArray = [...this.btnsArray, this.additionalSubmitBtn]);

    if (!this.variantSwatches.length) {
      // when there is no other variants but default (no variantSwatches on the page)
      this.toggleDisabledBtn(false);
    } else if (this.lookedCount !== this.variantSwatches.length) {
      // when we have more products in bundle than variantSwatches on the page
      this.lookedCount = this.variantSwatches.length;
    }

    this.eventListeners();
  }

  eventListeners() {
    this.btnsArray.forEach(btn => btn.addEventListener('click', this.handleSubmit.bind(this)))
    this.variantSwatches.forEach(swatch => {
      swatch.addEventListener('variant-changed', () => this.checkBundleItemsAvailability())
    })
  }

  async handleSubmit(e) {
    if (!this.productForms) return;

    this.toggleLoading({disable: true});

    for (let [i, form] of Array.from(this.productForms).entries()) {
      if (i === Array.from(this.productForms).length - 1) {
        await form.handleFetchPromise(true, this.toggleLoading.bind(this)({disable: false, timeout: 1500}));
      } else {
        await form.handleFetchPromise(false);
      }
    }
  }

  checkBundleItemsAvailability() {
    let count = 0;
    this.variantSwatches.forEach(swatch => {
      if (swatch.currentVariant.available) count++;
      if (count === this.lookedCount) this.toggleDisabledBtn({disable: false});
      if (count < this.lookedCount) this.toggleDisabledBtn({disable: true});
    })
  }

  toggleDisabledBtn({disable}) {
    this.btnsArray.forEach(btn => btn.toggleAttribute('disabled', disable))
  }

  toggleLoading({disable, timeout = 0}) {
    setTimeout(() => {
      this.btnsArray.forEach(btn => {
        btn.toggleAttribute('disabled', disable);
        btn.querySelector('.regular-text').classList.toggle('hidden', disable);

        btn.querySelector('.loading__spinner').classList.toggle('hidden', !disable);
        btn.querySelector('.loading-text').classList.toggle('hidden', !disable);
      })
    }, timeout);
  }
}

customElements.define('bundle-submit-button', BundleSubmitButton);

class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.abortControllerRef = {};
    this.selectedVariantIsHidden = Boolean(this.getAttribute('data-current-variant-hidden'));
  }

  connectedCallback() {
    this.updateOptions();
    this.updateMasterId();
    this.getVariantPreorderBadgeInfo();
    this.getVariantsVisibilityStatus();
    this.updateLegends();

    if (this.selectedVariantIsHidden) this.selectAnyAvailableFabricOption();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.getVariantPreorderBadgeInfo();
    this.getVariantsVisibilityStatus();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      if (this.dataset.section.indexOf('bundle') < 0) {
        this.renderProductInfo();
      } else {
        this.renderBundleProductInfo();
      }
      this.updateShareUrl();
      this.updateLegends();
    }

    this.dispatchEvent(new CustomEvent('variant-changed'));

    this.checkVariantVisibility();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => {
      try {
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
      } catch (error) {
        console.warn('Error setting active media for mediaGallery:', error);
      }
    });

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (!newMediaModal) return;
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    if (!fieldsets) return;
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('.form__label > span');
      const selectedFabric = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      legend.textContent = selectedFabric?.value || '';

      if (!fieldset.dataset.separatedFabrics) return;
      this.updateFabricsGroupTitles(fieldset, selectedFabric);
    });
  }

  updateFabricsGroupTitles(fieldset, selectedFabric) {
    const fabricGroups = fieldset.querySelectorAll('.product-form__separated-groups');
    fabricGroups.forEach(fabricGroup => {
      const selectedFabricWrapper = fabricGroup.querySelector('[data-selected-fabric]');

      if (selectedFabric.closest('.product-form__separated-groups') == fabricGroup) {
        selectedFabricWrapper.textContent = selectedFabric?.value || '';
      } else {
        selectedFabricWrapper.textContent = '';
      }
    })
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      const inputProps = productForm.querySelector('input[data-variant-property]');

      if (inputProps) inputProps.value = this.currentVariant.id;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (this.dataset.section.indexOf('bundle') < 0) {
      this.klaviyoNotify = document.querySelector('klaviyo-notify');
    } else {
      this.klaviyoNotify = this.closest('section[id*="MainProduct"]').querySelector('klaviyo-notify');
    }
    this.klaviyoNotify?.updateVariantId(this.currentVariant.id, this.currentVariant.available);
  }

  updatePreorderProperty(response) {
    const preorderInput = document.querySelector('#preorder-property');

    if (!preorderInput || !response.querySelector('#preorder-property')) return;

    preorderInput.outerHTML = response.querySelector('#preorder-property').outerHTML;
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);

      const optionInputsWithVisibility = selectedOptionOneVariants
        .filter((variant) => (variant[`option${index}`] === previousOptionSelected && !(Object.entries(this.variantsVisibilityData).find(i => i[0] == variant.id))[1]))
        .map((variantOption) => variantOption[`option${index + 1}`]);

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
      this.setInputHideStatus(optionInputs, optionInputsWithVisibility);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  setInputHideStatus(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled-forced');
      } else {
        input.classList.add('disabled-forced');
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability && pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    if (this.abortControllerRef.current) this.abortControllerRef.current.abort('Abort current request, the User have chosen another variant');

    this.abortControllerRef.current = new AbortController();
    const requestedVariantId = this.currentVariant.id;
    const signal = this.abortControllerRef.current.signal;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut
    );

    this.togglePersonalizeButton(
      this.currentVariant.available,
      window.variantStrings.soldOut
    );

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`, { signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        this.updatePreorderProperty(html);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      })
      .catch((e) => console.log(e))
  }

  renderBundleProductInfo() {
    if (this.abortControllerRef.current) this.abortControllerRef.current.abort('Abort current request, the User have chosen another variant');

    this.abortControllerRef.current = new AbortController();
    const signal = this.abortControllerRef.current.signal;
    const bundleSliderComponent = document.querySelector('bundle-slider-component');

    this.togglePersonalizeButton(this.currentVariant.available);
    if (bundleSliderComponent) bundleSliderComponent.toggleAdditionalBtns(this.currentVariant.available);

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`, { signal })
      .then((response) => response.text())
      .then((responseText) => {
        const closestMainSection = this.closest('section[id*="MainProduct"]');
        const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.product__info-wrapper');
        const sectionID = html.id.slice(html.id.indexOf('template'), html.id.length);
        const closestMainSectionID = closestMainSection.id.slice(
            closestMainSection.id.indexOf('template'),
            closestMainSection.id.length);

        const renderedPriceId = `price-${sectionID}`;
        const localPriceId = `price-${closestMainSectionID}`;

        const priceSource = html.querySelector(`#${renderedPriceId}`);
        const priceDestination = closestMainSection.querySelector(`#${localPriceId}`);

        this.updatePreorderProperty(html);

        if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
      })
      .catch((e) => console.log(e))
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButtons = [];
    const classicAddButton = productForm.querySelector('[name="add"]');
    const confirmationOpenerAddButton = productForm.querySelector('.product-confirmation-modal__button')

    if (classicAddButton) addButtons.push(classicAddButton);
    if (confirmationOpenerAddButton) addButtons.push(confirmationOpenerAddButton);

    if (!addButtons.length) return;

    addButtons.forEach(addButton => {
      const addButtonText = addButton.querySelector('span');

      this.handleButtonTextAndState(!disable, addButton, addButtonText, text);
    })

    if (!modifyClass) return;
  }

  togglePersonalizeButton(available = true, text) {
    const personalizeForm = document.getElementById(`Personalize-Form-${this.dataset.section}`);

    if (!personalizeForm) return;

    const personalizeModal = personalizeForm.closest('personalize-modal');
    const personalizePopupBtnWrapper = document.querySelector(`[data-modal="#${personalizeModal.id}"`);
    const personalizeButton = personalizePopupBtnWrapper.querySelector('.button--personalize');

    const addButton = personalizeForm.querySelector('[name="add_with_personalization"]');

    personalizeButton?.toggleAttribute('disabled', !available);
    personalizeButton?.classList.toggle('hidden', !available);
    personalizePopupBtnWrapper?.classList.toggle('hidden', !available);

    if (!addButton) return;

    const addButtonText = personalizeForm.querySelector('[name="add_with_personalization"] > span');

    this.handleButtonTextAndState(available, addButton, addButtonText, text);
  }

  handleButtonTextAndState(available, addButton, addButtonText, text) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    if (available) {
      const price = this.currentVariant.price / 100;
      const isVariantHasPreorder = this.variantsPreorderData ? Object.entries(this.variantsPreorderData).find(i => i[0] == this.currentVariant.id)[1] : false;

      addButton.removeAttribute('disabled');
      addButton.classList.remove('hidden');

      if (isVariantHasPreorder) {
        addButtonText.innerHTML = window.variantStrings.preorder;
      } else {
        addButtonText.innerHTML = window.variantStrings.addToCartHtml.replace(
          '{{ price }}',
          `${formatter.format(price).replace('.00', '')}`
        );
      }
    } else {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (text) addButton.classList.add('hidden');
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  selectAnyAvailableFabricOption() {
    setTimeout(() => {
      // we separate strict and non-strict selection because we might have the case
      // when all options are disabled but not forced-disabled, so in that case we need to select any option
      // (case when all variants are sold out)
      const strictTarget = this.querySelector('input[type="radio"]:not(.disabled):not(.disabled-forced)[name="Fabric"]');
      const target = this.querySelector('input[type="radio"]:not(.disabled-forced)[name="Fabric"]');

      if (!target && !strictTarget) {
        this.selectAnyAvailableColorOption();
        return;
      }

      if (strictTarget) strictTarget.click();
      else target.click();
    }, 100);
  }

  selectAnyAvailableColorOption() {
    // we separate strict and non-strict selection because we might have the case
    // when all options are disabled but not forced-disabled, so in that case we need to select any option
    // (case when all variants are sold out)
    const strictTarget = this.querySelector('input[type="radio"]:not(.disabled):not(.disabled-forced)[name="Color"]');
    const target = this.querySelector('input[type="radio"]:not(.disabled-forced)[name="Color"]');

    if (!target && !strictTarget) return;

    if (strictTarget) strictTarget.click();
    else target.click();
  }

  checkVariantVisibility() {
    this.getVariantsVisibilityStatus();
    if (!this.variantsVisibilityData || !this.currentVariant) return false;
    const variantIsHidden = Object.entries(this.variantsVisibilityData).find(i => i[0] == this.currentVariant.id)[1];

    if (variantIsHidden) {
      // we separate strict and non-strict selection because we might have the case
      // when all options are disabled but not forced-disabled, so in that case we need to select any option
      // (case when all variants are sold out)
      const strictTarget = this.querySelector('input[type="radio"]:not(.disabled):not(.disabled-forced)[name="Fabric"]');
      const target = this.querySelector('input[type="radio"]:not(.disabled-forced)[name="Fabric"]');

      if (!target && !strictTarget) return;

      if (strictTarget) strictTarget.click();
      else target.click();
    }
  }

  getVariantData() {
    this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getVariantPreorderBadgeInfo() {
    this.variantsPreorderData = JSON.parse(this.querySelector('#Variants-Ship-Badge[type="application/json"]')?.textContent || 'null');
    return this.variantsPreorderData;
  }

  getVariantsVisibilityStatus() {
    this.variantsVisibilityData = JSON.parse(this.querySelector('#Hidden-Variants[type="application/json"]')?.textContent || 'null');
    return this.variantsVisibilityData;
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class ProductForm extends HTMLElement {
  constructor() {
    super();

    // elements
    this.form = this.querySelector('form');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.submitButton = this.querySelector('[type="submit"]');

    // variables
    this.hideErrors = this.dataset.hideErrors === 'true';
  }

  connectedCallback() {
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

    if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');

    this.handleFetchPromise();
  }

  handleFetchPromise(openCart = true, finallyCallback) {
    const config = fetchConfig('javascript');
    const formData = new FormData(this.form);

    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    formData.append('sections', this.cartDrawer.sectionsToRender.map((section) => section.sectionID));
    formData.append('sections_url', window.location.pathname);
    this.cartDrawer.setActiveElement(document.activeElement);

    config.body = formData;

    return fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        this.error = false;
        const personalizeModal = document.querySelector('personalize-modal');
        const personalizeButton = document.querySelector('.button--personalize');
        if (personalizeModal && personalizeButton && personalizeModal.isOpen()) {
          personalizeModal.hide();
        }

        if (!openCart) return;
        this.cartDrawer.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (finallyCallback) finallyCallback();

        this.submitButton.classList.remove('loading');
        if (this.cartDrawer.classList.contains('is-empty')) this.cartDrawer.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper =
      this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

customElements.define('product-form', ProductForm);

class AddToRegistryCTA extends HTMLElement {
  constructor() {
    super();

    this.script = this.querySelector('script');
    this.initialValues = JSON.parse(this.script.innerHTML);
    this.productFormId = this.getAttribute('data-product-form-id');
    this.personalizeModal = document.querySelector('personalize-modal');
    this.personalizeForm = this.personalizeModal?.querySelector('personalize-form');
    this.confirmationModal = document.querySelector('personalization-confirmation-modal');
    this.showConfirmationPopup = JSON.parse(this.getAttribute('data-show-confirmation-popup') || false);

    this.btn = this.querySelector('button');
    this.variantRadios = document.querySelector(`#${this.productFormId}`)
      .closest('div[id^="ProductInfo"]')
      .querySelector('variant-radios');

    this.data = this.initialValues;
    this.disableConfirmationModalValue = false;
  }

  connectedCallback() {
    this.checkURL();
    this.handleUpdateURL();

    this.btn.addEventListener('click', () => this.handleBtnClick())
    this.variantRadios?.addEventListener('variant-changed', (e) => this.handleVariantChange(e.target.currentVariant))
  }

  openRegistryModal() {
    if (!window.bl || !this.data) return;

    if (this.confirmationModal && this.confirmationModal.hasAttribute('open')) this.confirmationModal.hide();
    if (this.personalizeModal && this.personalizeModal.hasAttribute('open')) this.personalizeModal.hide();

    bl.addToRegistry(this.data);
  }

  checkURL() {
    if (!Object.fromEntries(new URLSearchParams(location.search)).disableConfirmationModal) return;
    this.disableConfirmationModalValue = JSON.parse(Object.fromEntries(new URLSearchParams(location.search)).disableConfirmationModal);
    if (this.disableConfirmationModalValue) this.showConfirmationPopup = false;
  }

  mutateURL() {
    return `${window.location.href}${window.location.search ? '&' : '?'}disableConfirmationModal=${!this.personalizeForm?.itemPersonalized}`;
  }

  handleBtnClick() {
    if (this.showConfirmationPopup && !this.personalizeForm?.itemPersonalized && this.confirmationModal) {
      this.confirmationModal.show(this.btn, 'registry');
    } else {
      this.openRegistryModal();
    }
  }

  handleVariantChange(variant) {
    if (!variant) return;

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    const price = formatter.format(variant.price / 100).replace('.00', '');

    this.data.images = variant.featured_image ? variant.featured_image.src : null;
    this.data.price = price;
    this.data.title = variant.name;

    this.handleUpdateURL();
  }

  handleUpdateURL() {
    this.data.url = this.mutateURL();

    this.updateScript();
  }

  sendEventToGTM() {
    // pause this one for now => send data through GTM directly
    // window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //   event: 'add_to_registry_btn_click'
    // });
  }

  updateScript() {
    this.script.innerHTML = JSON.stringify(this.data);
  }
}

customElements.define('add-to-registry', AddToRegistryCTA);

if (!customElements.get('custom-accordion')) {
  class Accordion extends HTMLElement {
    constructor() {
      super();

      this.headings = this.querySelectorAll('[data-accordion-heading]');
      this.body = this.querySelector('[data-accordion-body]');
      this.inner = this.querySelector('[data-accordion-body]');
      this.singleOpened = this.dataset.singleOpened;
      this.openAccordion = this.dataset.openAccordion;
      this.closeOnFocusOut = this.dataset.closeOnClickOut

      this.init();
    }

    init() {
      if (!this.headings.length) return;

      this.headings.forEach(item => {
        item.addEventListener('click', (e) => {
          let accordionsArray = [];
          if (this.singleOpened === "false") accordionsArray.push(item.closest('custom-accordion'));
          else accordionsArray = document.querySelectorAll(`[data-connected-target="${this.dataset.connectedTarget}"]`);

          accordionsArray.forEach((accordion) => {
            const panel = accordion.querySelector('[data-accordion-opener]');
            if (accordion.contains(item.parentNode)) {
              accordion.querySelector('[data-accordion-body]').classList.toggle("open");
              accordion.slideToggle(panel);
            } else {
              accordion.querySelector('[data-accordion-body]').classList.remove("open");
              accordion.slideUp(panel);
            }
          })
        })

        const accordion = item.closest('custom-accordion');
        const panel = accordion.querySelector('[data-accordion-opener]');
        let additionalHeight = 60;

        if (accordion.openAccordion !== "true") return;
        accordion.slideDown(panel, additionalHeight);
        accordion.querySelector('[data-accordion-body]').classList.add("open");
      });


      document.addEventListener('click', (e) => {
        if (e.target.closest('custom-accordion')) return;
        if (this.closeOnFocusOut !== "true") return;
        const connectedAccordions = document.querySelectorAll(`[data-connected-target="${this.dataset.connectedTarget}"]`);
        connectedAccordions.forEach(accordion => {
          const panel = accordion.querySelector('[data-accordion-opener]');
          accordion.querySelector('[data-accordion-body]').classList.remove("open");
          accordion.slideUp(panel);
        })
      })
    }

    slideUp(panel) {
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      }
    }

    slideDown(panel, additionalHeight = 60) {
      panel.style.maxHeight = panel.scrollHeight + additionalHeight + "px";
    }

    slideToggle(panel) {
      if (panel.style.maxHeight) {
        this.slideUp(panel);
      } else {
        this.slideDown(panel);
      }
    }
  }

  customElements.define('custom-accordion', Accordion);
}
